import React, { useContext } from 'react';
import { TypeAnimation } from 'react-type-animation';
import './SimpleHeader.css';
import { ThemeContext } from '../../contexts/ThemeContext';
import { headerData } from '../../data/headerData';

function SimpleHeader() {
    const { theme } = useContext(ThemeContext);

    return (
        <div className='header'>
            <div className='header--container'>
                <div className='header--container-left'>
                    <div className='header-left-content'>
                        &nbsp;
                    </div>
                </div>
                <div
                    className='header--container-right'>
                        <div
                            className='header-right-content'
                            style={{textAlign:'left'
                            }}
                        >
                        <div className='headerTitle'>
                            <span>{headerData.prefix}</span>
                            <span style={{color:theme.tertiary,backgroundColor:theme.secondary}}>
                                <TypeAnimation
                                sequence={[
                                    // Same substring at the start will only be typed out once, initially
                                    headerData.title,
                                    500, // wait 1s before replacing "Mice" with "Hamsters"
                                    headerData.title1,
                                    500,
                                    headerData.title2,
                                    500,
                                    headerData.title3,
                                    500
                                ]}
                                // style={{ fontFamily: 'Monoton' }}
                                wrapper="span"
                                speed={50}
                                repeat={0}
                            />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SimpleHeader;
